import { render } from "./About.vue?vue&type=template&id=e29b7a8a&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=e29b7a8a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29b7a8a"]])

export default __exports__